import { registerComponent } from '@gig/magic-common';
import QuickPaymentComponent from './quick-payment.vue.js';

var QuickPayment = registerComponent(QuickPaymentComponent);

export { QuickPayment };
